import { Injectable } from '@angular/core'
import { environment } from '@environments/environment'
import { InsuredNavigationItem } from '../models/insured-navigation-item.model'
import { AbstractContentSidebarStateService } from './abstract-content-sidebar-state.service'
import { Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class InsuredSidebarStateService extends AbstractContentSidebarStateService<InsuredNavigationItem> {
  public readonly insuredList$ = this.itemList$
  protected override readonly apiUrl = environment.memberApiUrl
  protected override readonly subsystemName = 'Insured List Loading'
  protected override readonly errorDescription = 'Could not load the list of Insured.'
  protected override readonly listEndpoint = 'navigation-list'
  protected override readonly useCategory = true

  public loadMoreInsuredItems(page: number, size = 20): Observable<InsuredNavigationItem[]> {
    return this.loadMoreItems(page, size)
  }
}
